import { Routes, Route, Navigate } from "react-router";
import { useSelector } from "react-redux";

import Login from "pages/login";
import LeftSidebar from "LeftSidebar";

import {
  ChangePassword,
  Payments,
  PaymentDetails,
  TourDetails,
  HeroSection,
  MenuSlider,
  PickupDelivery,
  ProductsList,
  ProductForm,
  ProductDetail,
  ContactUsContacts,
  ContactUsLocations,
  ContactUsSocialMedia,
  ContactUsMetaDetails,
  AboutContent,
  AboutStatsList,
  AboutStatsForm,
  AboutStatsDetail,
  AboutStatsSection,
  AboutImagesList,
  AboutImagesForm,
  AboutImagesDetail,
  GalleryMetaDetails,
  AboutMetaDetails,
  HomeMetaDetails,
  MenuCategories,
  MenuCategoryForm,
  MenuMetaDetails,
  PrivacyPolicyContent,
  PrivacyPolicyMetaDetails,
} from "pages";

const PageRoutes = () => {
  const { isAuth } = useSelector((state) => state.auth);

  return (
    <>
      {!isAuth ? (
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/*" element={<Navigate to="/login" replace />} />
        </Routes>
      ) : (
        <LeftSidebar>
          <Routes>
            <Route path="/change-password" element={<ChangePassword />} />
            <Route path="/payments" element={<Payments />} />
            <Route path="/payments/:id" element={<PaymentDetails />} />
            <Route
              path="/payments/:id/tour-details/:tourId"
              element={<TourDetails />}
            />

            {/* Home Routes */}
            <Route path="/hero-section" element={<HeroSection />} />
            <Route path="/menu-slider" element={<MenuSlider />} />
            <Route path="/pickup-delivery" element={<PickupDelivery />} />
            <Route path="/home-meta-details" element={<HomeMetaDetails />} />

            <Route path="/products" element={<ProductsList />} />
            <Route path="/products/create" element={<ProductForm />} />
            <Route path="/products/:id" element={<ProductDetail />} />
            <Route path="/products/:id/edit" element={<ProductForm />} />

            <Route
              path="/contact-us/contacts"
              element={<ContactUsContacts />}
            />
            <Route
              path="/contact-us/locations"
              element={<ContactUsLocations />}
            />
            <Route
              path="/contact-us/social-media"
              element={<ContactUsSocialMedia />}
            />
            <Route
              path="/contact-us/meta-details"
              element={<ContactUsMetaDetails />}
            />

            <Route path="/about" element={<AboutContent />} />
            <Route path="/about-stats" element={<AboutStatsList />} />
            <Route path="/about-stats/create" element={<AboutStatsForm />} />
            <Route path="/about-stats/:id" element={<AboutStatsDetail />} />
            <Route path="/about-stats/:id/edit" element={<AboutStatsForm />} />
            <Route
              path="/about-stats-section"
              element={<AboutStatsSection />}
            />

            <Route path="/about-images" element={<AboutImagesList />} />
            <Route path="/about-images/create" element={<AboutImagesForm />} />
            <Route path="/about-images/:id" element={<AboutImagesDetail />} />
            <Route
              path="/about-images/:id/edit"
              element={<AboutImagesForm />}
            />

            <Route
              path="/gallery-meta-details"
              element={<GalleryMetaDetails />}
            />
            <Route path="/about-meta-details" element={<AboutMetaDetails />} />

            <Route path="/menu-categories" element={<MenuCategories />} />
            <Route
              path="/menu-categories/create"
              element={<MenuCategoryForm />}
            />
            <Route
              path="/menu-categories/:id/edit"
              element={<MenuCategoryForm />}
            />
            <Route path="/menu-meta-details" element={<MenuMetaDetails />} />

            <Route
              path="/privacy-policy-content"
              element={<PrivacyPolicyContent />}
            />
            <Route
              path="/privacy-policy-meta-details"
              element={<PrivacyPolicyMetaDetails />}
            />

            <Route
              path="/*"
              element={<Navigate to="/hero-section" replace />}
            />
          </Routes>
        </LeftSidebar>
      )}
    </>
  );
};

export default PageRoutes;
